import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-click",
  "use": "icon-click-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-click\"><path d=\"M389.632 848.384H40.96V81.92h942.08v265.318h-81.92V163.84H122.88v602.624h266.752v81.92z\" /><path d=\"M403.968 377.037l195.994 564.838 119.09-257.433L980.276 565.35 403.968 377.037z\" /><path d=\"M690.842 710.277l57.835-58.02L891.26 794.388l-57.836 58.02z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol